var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js
// module id = ../../node_modules/babel-runtime/node_modules/core-js/library/modules/_html.js
// module chunks = widget-6.25.3